import { UseMutationResult, useMutation } from 'react-query';

import { getTokenWithType } from './useAuth';

import { previewExternalFile } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchExternalFilePreview(payload: string): Promise<any> {
  const response = await fetch(previewExternalFile(payload), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return await response.json();
  } else {
    const blob = await response.blob();
    return {
      Data: {
        Content: blob,
        FileName: 'filename',
        FileType: contentType,
      },
      IsSuccess: true,
      StatusCode: response.status,
    };
  }
}

type TResult = {
  Data: {
    Content: string;
    FileName: string;
    FileType: string;
  };
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TError = ErrorModal;

type TSnapshot = unknown;

function usePreviewExternalFileUpload(): UseMutationResult<
  TResult,
  TError,
  string,
  TSnapshot
> {
  return useMutation(async (payload: string) => {
    const fetchResponse = await fetchExternalFilePreview(payload);
    return fetchResponse;
  });
}

export { usePreviewExternalFileUpload };
